'use client';

import React from 'react';
import Image from '@/components/atoms/image';
import BupiLink from '@/components/atoms/link';
import { RichTextRenderer } from './RichTextRenderer';

export interface StepContentProps {
  title: string;
  description?: string;
  image?: {
    url: string;
    alt: string;
  };
  imageDescription?: string;
  headerColor?: string;
  ctaButton?: {
    label: string;
    url: string;
    target?: '_self' | '_blank' | string;
    style: 'solid';
  };
  index: number;
}

export const StepContent: React.FC<StepContentProps> = ({
  description,
  image,
  imageDescription,
  ctaButton,
  index,
}) => {
  return (
    <div
      className={`flex flex-col ${index % 2 === 0 ? (!imageDescription) ? 'md:flex-col xl:flex-row-reverse' : ' md:flex-row-reverse' : ' xl:flex-row'
        } items-center gap-32 w-full bg-white py-[44px] md:py-64`}
    >
      <div className={`flex flex-col  ${index % 2 === 0 ? 'md:flex-row-reverse md:items-center' : 'md:flex-row '} xl:flex-col items-start justify-center gap-32 xl:gap-12 w-full`}>
        {image && (
          <div className="relative w-full max-w-[296px] md:max-w-[304px] xl:max-w-[592px] aspect-[4/3] shrink-0">
            <Image
              fill
              alt={image?.alt || ""}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              src={image?.url || ""}
              className="object-contain"
            />
          </div>
        )}

        {imageDescription && (
          <div className="self-center w-full flex justify-center">
            <div className="w-full xl:max-w-[384px] text-m-regular">
              {imageDescription}
            </div>
          </div>
        )}
      </div>

      <div className={`w-full xl:max-w-[590px] flex flex-col ${index % 2 === 0 ? '' : 'flex-row-reverse'} items-start gap-32 md:gap-[44px]`}>
        {description && (
          <div className="prose max-w-none">
            <RichTextRenderer content={description} />
          </div>
        )}

        {ctaButton && (
          <BupiLink
            label={ctaButton.label}
            url={ctaButton.url}
            hasIcon
            className="py-8"
            target={ctaButton.target || "_self"}
          />
        )}
      </div>
    </div>
  );
};